import React, { useState } from 'react';
function SharedGPAto100() {
    const [originalGPA, setOriginalGPA] = useState('');
    const [convertedPercentage, setConvertedPercentage] = useState('');
    const [showResult, setShowResult] = useState(false);
    const [error, setError] = useState(null);
    const handleCalculateClick = () => {
        const gpa = parseFloat(originalGPA);
        if (!isNaN(gpa) && gpa >= 0 && gpa <= 4.0) {
            let calculatedPercentage = 0;
            if (gpa >= 3.97 && gpa <= 4.0) {
                calculatedPercentage = 100;
            } else if (gpa >= 3.92 && gpa <= 3.96) {
                calculatedPercentage = 99;
            } else if (gpa >= 3.88 && gpa <= 3.91) {
                calculatedPercentage = 98;
            } else if (gpa >= 3.84 && gpa <= 3.87) {
                calculatedPercentage = 97;
            } else if (gpa >= 3.80 && gpa <= 3.83) {
                calculatedPercentage = 96;
            } else if (gpa >= 3.75 && gpa <= 3.79) {
                calculatedPercentage = 95;
            } else if (gpa >= 3.71 && gpa <= 3.74) {
                calculatedPercentage = 94;
            } else if (gpa >= 3.67 && gpa <= 3.70) {
                calculatedPercentage = 93;
            } else if (gpa >= 3.62 && gpa <= 3.66) {
                calculatedPercentage = 92;
            } else if (gpa >= 3.58 && gpa <= 3.61) {
                calculatedPercentage = 91;
            } else if (gpa >= 3.49 && gpa <= 3.57) {
                calculatedPercentage = 90;
            } else if (gpa >= 3.41 && gpa <= 3.48) {
                calculatedPercentage = 89;
            } else if (gpa >= 3.32 && gpa <= 3.40) {
                calculatedPercentage = 88;
            } else if (gpa >= 3.24 && gpa <= 3.31) {
                calculatedPercentage = 87;
            } else if (gpa >= 3.15 && gpa <= 3.23) {
                calculatedPercentage = 86;
            } else if (gpa >= 3.07 && gpa <= 3.14) {
                calculatedPercentage = 85;
            } else if (gpa >= 2.98 && gpa <= 3.06) {
                calculatedPercentage = 84;
            } else if (gpa >= 2.90 && gpa <= 2.97) {
                calculatedPercentage = 83;
            } else if (gpa >= 2.81 && gpa <= 2.89) {
                calculatedPercentage = 82;
            } else if (gpa >= 2.72 && gpa <= 2.80) {
                calculatedPercentage = 81;
            } else if (gpa >= 2.64 && gpa <= 2.71) {
                calculatedPercentage = 80;
            } else if (gpa >= 2.56 && gpa <= 2.63) {
                calculatedPercentage = 79;
            } else if (gpa >= 2.48 && gpa <= 2.55) {
                calculatedPercentage = 78;
            } else if (gpa >= 2.40 && gpa <= 2.47) {
                calculatedPercentage = 77;
            } else if (gpa >= 2.32 && gpa <= 2.39) {
                calculatedPercentage = 76;
            } else if (gpa >= 2.24 && gpa <= 2.31) {
                calculatedPercentage = 75;
            } else if (gpa >= 2.16 && gpa <= 2.23) {
                calculatedPercentage = 74;
            } else if (gpa >= 2.08 && gpa <= 2.15) {
                calculatedPercentage = 73;
            } else if (gpa >= 2.00 && gpa <= 2.07) {
                calculatedPercentage = 72;
            } else if (gpa >= 1.92 && gpa <= 1.99) {
                calculatedPercentage = 71;
            } else if (gpa >= 1.84 && gpa <= 1.91) {
                calculatedPercentage = 70;
            } else if (gpa >= 1.75 && gpa <= 1.83) {
                calculatedPercentage = 69;
            } else if (gpa >= 1.67 && gpa <= 1.74) {
                calculatedPercentage = 68;
            } else if (gpa >= 1.59 && gpa <= 1.66) {
                calculatedPercentage = 67;
            } else if (gpa >= 1.51 && gpa <= 1.58) {
                calculatedPercentage = 66;
            } else if (gpa >= 1.43 && gpa <= 1.50) {
                calculatedPercentage = 65;
            } else if (gpa >= 1.35 && gpa <= 1.42) {
                calculatedPercentage = 64;
            } else if (gpa >= 1.26 && gpa <= 1.34) {
                calculatedPercentage = 63;
            } else if (gpa >= 1.18 && gpa <= 1.25) {
                calculatedPercentage = 62;
            } else if (gpa >= 1.09 && gpa <= 1.17) {
                calculatedPercentage = 61;
            } else if (gpa >= 1.00 && gpa <= 1.08) {
                calculatedPercentage = 60;
            } else {
                calculatedPercentage = 0;
            }
            setConvertedPercentage(calculatedPercentage);
            setShowResult(true);
            setError(null);
        } else {
            setError('Enter a valid value between 0 and 4.0');
            setShowResult(false);
        }
    };
    return (
        <div>
            <div className="row">
                <div className="col-sm-12 col-md-7 calculatorStyle">
                    <div className="p-3 mb-2 bg-success text-white">
                        <h2 style={{ fontSize: '16px' }}>Convert Cumulative GPA to 100 Scale</h2>
                    </div>
                    <hr />
                    <div className="form-group d-flex align-items-center">
                        <b><label htmlFor='originalGPA'>Cumulative GPA:</label></b>
                        <input
                            type="text"
                            value={originalGPA}
                            id="originalGPA"
                            onChange={(e) => setOriginalGPA(e.target.value)}
                            className='form-control'
                            style={{ width: '200px', marginRight: '4px' }}
                        />
                    </div>
                    <button className="btn btn-success mt-3" onClick={handleCalculateClick}>
                        Calculate
                    </button>
                    <br />
                </div>
            </div>
            <br />
            <div className="row">
                <div className="col-sm-12 col-md-7">
                    {error && <div className="alert alert-warning"><b><u>Error:</u></b> Please enter all fields correctly.</div>}
                    {showResult && (
                        <div style={{ fontSize: '17px' }} className=" bg-light bg-gradient text-dark">
                            <div className="p-3 bg-success bg-gradient text-white">
                                <strong>Results:</strong>
                            </div>
                            <b>Percentage: {convertedPercentage}</b>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
export default SharedGPAto100;
